jQuery(document).ready(function($) {
  $('.m-study__filter--gov input').focus( function() {
    //$('.m-study__filter--gov input:checked').addClass('test');
  });
});